import React from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  Form,
  Input,
  Modal,
  Row,
  Col
} from 'antd'
import { defineMessages } from 'react-intl'
import './ChangePasswordModal.scss'

const messages = defineMessages({
  warningPasswordsAreDifferent: '兩次輸入的新密碼不同，重新輸入',
  labelOldPassword: '舊密碼',
  labelNewPassword: '新密碼',
  changepassword_form_title: '密碼變更',
  changepassword_form_btnEdit: '確定',
  changepassword_form_btnCancel: '取消'
})

class ChangePasswordForm extends React.Component {
  static contextTypes = {
    intl: PropTypes.object,
  };
  static propTypes = {
    isLoading: PropTypes.bool,
    changePasswordErrorMessage: PropTypes.string,
    onSubmit: PropTypes.func,
    show: PropTypes.func,
    onHide:PropTypes.func
  };

  constructor (props) {
    super(props)
    this.state = {
      password: '',
      confirmingPassword: '',
      showAlert: false,
      errorMessage: '',
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.changePasswordErrorMessage) {
      this.setState({
        showAlert: true,
        errorMessage: nextProps.changePasswordErrorMessage
      })
    }
  }

  onHide = () => {
    this.setState((prevState, props) => ({ ...this.defaultState }))
    this.props.onHide()
  }
  handleSubmit = (event) => {
    event.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSubmit(values)
      } else {

      }
    })
    this.onHide()
  }
  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props
    if (value && value == form.getFieldValue('password')) {
      callback('密碼請勿設定一樣')
    } else {
      callback()
    }
  }

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true })
    }
    callback()
  }
  render () {
    const {
      intl: { formatMessage },
    } = this.context
    const {
      show,
      form
    } = this.props
    const {} = this.state
    const { getFieldDecorator } = form
    let submitBtnText = formatMessage(messages.changepassword_form_btnEdit)
 
    return (
      <Modal
        centered
        title={formatMessage(messages.changepassword_form_title)}
        width={400} // 690
        visible={show}
        onCancel={this.onHide}
        wrapClassName={'changeformmodal'}
        footer={null}
      >
      <div style={{ color: '#FFFFFF', fontSize: 18, paddingLeft: 15, border:'0px solid #FFFFFF' }}>
        <Form layout='horizontal'>
          <Form.Item label={<p style={{ color: '#ffffff', display: 'inline' }}>{formatMessage(messages.labelOldPassword)}</p>} colon={false}>
            {getFieldDecorator('password', {
              rules: [
              { required: true, message: '請輸入現在密碼' },
              { validator: this.validateToNextPassword }
              ]
            })(
              <Input.Password />
          )}
          </Form.Item>
          <Form.Item label={<p style={{ color: '#ffffff', display: 'inline' }}>{formatMessage(messages.labelNewPassword)}</p>} colon={false}>
            {getFieldDecorator('password2', {
              rules: [
                { required: true, message: '請輸入新密碼' },
                { validator: this.compareToFirstPassword }
              ]
            })(
              <Input.Password onBlur={this.handleConfirmBlur} />
          )}
          </Form.Item>
        </Form>
        <Row gutter={16} style={{ paddingBottom: 12, marginTop:12 }}>
          <Col span={13} />
          <Col span={5}><Button type='primary' onClick={this.onHide}>{formatMessage(messages.changepassword_form_btnCancel)}</Button></Col>
          <Col span={5}><Button type='primary' onClick={this.handleSubmit}>{submitBtnText}</Button></Col>
          <Col span={1} />
        </Row>
      </div>
      </Modal>
    )
  }
}

const CHANGE_PASSWORD = Form.create()(ChangePasswordForm)

export default CHANGE_PASSWORD



// WEBPACK FOOTER //
// ./src/components/ChangePasswordPanel/ChangePasswordForm.js